import "intersection-observer";
import "svgxuse";
import "url-search-params-polyfill";

import objectFitImages from "object-fit-images";
import "picturefill";
objectFitImages();

import objectFitVideos from "object-fit-videos";
objectFitVideos();

import lazyloadPicturefillBackground from "lazyload-picturefill-background";
new lazyloadPicturefillBackground();
